<template>
    <div class="item-question-input-dependent-pull-down">
        <div class="d-flex flex-row">
            <label v-if="numberContent != ''" class="text-color-number mb-1">
                {{ numberContent }}
            </label>
            <label class="bold text-color-questions mb-1 ps-2"
                   v-html="labelContent">
            </label>
        </div>
        <div
            v-if="question.additionalInfo"
            class="form-input-help mb-1"
            v-html="question.additionalInfo"
        >
        </div>
        <div class="row content-pull-down d-flex flex-wrap">
            <div id="divPullDown1" class="col-12 col-md-6">
                <select-input :error-text="'Question is required'"
                              :field-id="question.questionId"
                              :input-class="'form-select question-input-text-select'"
                              :label="question.descriptionPd1"
                              :label-class="'text-color-questions'"
                              :model-answer="parentValue"
                              :name="'PD1question_' + TYPE_FIELD_ID + '_' + question.questionId "
                              :options="parentOptions"
                              :question="question"
                              :text-select="translateLabels.textSelect"
                              :type="'pulldown'"
                              :validation="validationRules"
                              v-on:update:modelAnswer="parentValue = $event" />
            </div>
            <div id="divPullDown2" class="col-12 col-md-6">
                <select-input :error-text="'Question is required'"
                              :field-id="question.questionId"
                              :input-class="'form-select question-input-text-select'"
                              :label="question.descriptionPd2"
                              :label-class="'text-color-questions'"
                              :model-answer="childValue"
                              :name="'question_' + TYPE_FIELD_ID + '_' + question.questionId"
                              :options="childOptions"
                              :question="question"
                              :text-select="translateLabels.textSelect"
                              :type="'pulldown'"
                              :validation="validationRules"
                              v-on:update:modelAnswer="childValue = $event"/>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, computed, watch } from 'vue';
import SelectInput from "../components/select-input.vue";

// INITIALIZE STORE & COMPOSABLES

// PROPS & EMITS
const props = defineProps({
    enumeration: {
        type: Number,
        required: false,
        default: 0,
    },
    question: {
        type: Object,
        required: true,
    },
    showNumbering: {
        type: Boolean,
        required: false,
        default: false,
    },
    translateLabels: {
        type: Object,
        required: true,
    },
    TYPE_FIELD_ID: {
        type: Number,
        required: true,
    },
});

// REACTIVE VARIABLES
const parentValue = ref('');
const childValue = ref('');

// COMPUTED PROPERTIES
const childOptions = computed(() => {
    const options = {};
    if (parentValue.value === '') {
        return options;
    }
    const currentParentValue = parentValue.value;
    props.question.options.forEach((element) => {
        if (element.parentOptionId == currentParentValue) {
            const value = element.optionId;
            options[value] = element.additionalInfo;
        }
    });
    return options;
});

const labelContent = computed(() => {
    const label = [];

    if (props.question.required) {
        label.push(`* ${props.question.description}`);
    } else {
        label.push(props.question.description);
    }

    return label.join(' ');
});

const numberContent = computed(() => {
    const label = [];

    if (Boolean(props.showNumbering)) {
        label.push(`${String(props.enumeration).padStart(2, '0')}.`);
    }

    return label.join(' ');
});

const parentOptions = computed(() => {
    const options = {};
    props.question.options.forEach((element) => {
        const value = element.parentOptionId;
        options[value] = String(element.description);
    });
    return options;
});

const validationRules = computed(() => {
    const rules = {
        required: false,
    };
    if (props.question.required) {
        rules.required = true;
    }

    return rules;
});

// METHODS
/*const onUpdateModelData = (value) => {
    parentValue.value = value;
};*/

// LIFECYCLE HOOKS
watch(childValue, () => {
    if (parentValue.value === '') {
        const currentChildValue = childValue.value;
        const options = props.question.options.filter((element) => element.optionId == currentChildValue);
        parentValue.value = options[0].parentOptionId;
    }
});
</script>
